module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"authErrorPageTitle":"Ошибка авторизации","authErrorTitle":"Ошибка авторизации","authErrorText":"Проверьте логин и пароль и попробуйте ещё раз","authErrorButton":"Вернуться на главную"}}')
  delete Component.options._Ctor
}
